import JotFormEmbed from "components/JotFormEmbed"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function NewsletterSignUpForm({ blok }) {
  return (
    <div className="bg-primary px-5 py-8 xl:py-14 xl:px-7">
      <div className="text-white lg:text-center prose-headings:pb-4 prose-headings:text-white prose-h2:pb-4 prose-h2:text-white lg:prose-p:text-center pb-8 max-w-3xl mx-auto">
        {richText(blok?.content)}
      </div>
      <JotFormEmbed formURL={getStoryblokLink(blok?.jotform_url)} initialHeight={400} />
    </div>
  )
}
